import React, { useState } from 'react';
import { APP_URL } from '../constants';

const SeoPreview = ({ initialData, onChange }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [seoData, setSeoData] = useState(initialData);

  const slugLimit = 50;  // Maximum characters for the slug
  const descriptionLimit = 160; // Maximum characters for the meta description

  // Function to remove HTML tags from a string
  const removeHtmlTags = (str) => {
    return str.replace(/<[^>]*>/g, ''); // Regular expression to remove HTML tags
  };

  // Function to limit description length
  const truncateDescription = (text, maxLength = descriptionLimit) => {
    const strippedText = removeHtmlTags(text); // Remove HTML tags first
    if (strippedText.length <= maxLength) return strippedText;
    return strippedText.slice(0, maxLength) + '...';
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedData = { ...seoData, [name]: value };
    setSeoData(updatedData);
    if (onChange) onChange(updatedData);
  };

  return (
    <div className="p-0">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h5 className="mb-0">SEO Preview</h5>
        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setIsEditing(!isEditing)}>
          <i className="bi bi-pencil me-1"></i> {isEditing ? 'Close' : 'Edit'}
        </button>
      </div>

      {!isEditing ? (
        <div className="border rounded p-3 bg-light">
          <div className="text-primary fs-5">{seoData.metaTitle || 'Page Title'}</div>
          <div className="text-success">
            <a
              href={seoData.slug ? `${APP_URL}${seoData.structure}${seoData.slug}` : undefined}
              target="_blank"
              rel="noopener noreferrer"
              className="text-success text-decoration-none"
            >
              {seoData.slug ? `${APP_URL}${seoData.structure}${seoData.slug}` : ''}
              <i className="bi bi-box-arrow-up-right ms-2"></i>
            </a>
          </div>
          <div className="text-dark">{truncateDescription(seoData.metaDescription || 'Meta description will be shown here.')}</div>
        </div>
      ) : (
        <div className="row g-3 mt-1">
          <div className="col-12">
            <label className="form-label">Slug</label>
            <input
              type="text"
              className="form-control"
              name="slug"
              value={seoData.slug}
              onChange={handleChange}
              placeholder="page-slug"
              maxLength={slugLimit}
            />
            <small className="text-muted">{`Max ${slugLimit} characters`}</small>
          </div>

          <div className="col-12">
            <label className="form-label">Meta Description</label>
            <textarea
              className="form-control"
              name="metaDescription"
              value={seoData.metaDescription}
              onChange={handleChange}
              placeholder="Enter meta description"
              maxLength={descriptionLimit}
            />
            <small className="text-muted">{`Max ${descriptionLimit} characters`}</small>
          </div>
        </div>
      )}
    </div>
  );
};

export default SeoPreview;
